$(document).ready(function () {
  $(".banners_list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 681,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

  $(".upsell_cart_product").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });
  
  const intervalId = setInterval(() => {
     $(".recommendations_container").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1367,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 551,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1.45,
          },
        }
      ]
    });
    
    if ($('.recommendations_container').hasClass('slick-initialized')) {
      clearInterval(intervalId);
    }
  }, 500); 
  
   $(".reviewBox").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

  $(".mobile-banner-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".jdgm-preview-badge").click(function() {
     $('.tab_last').trigger('click');
  });
  
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  
  $('.product-list').slick('refresh');

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-list').slick('refresh');
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");

document.addEventListener("DOMContentLoaded", function () {

  function mobileSlider() {

    if (window.innerWidth <= 550) {

      if (!$('.home-collections-tab .product-list').hasClass('slick-initialized')) {
        $('.home-collections-tab .product-list').slick({
          slidesToShow: 1.45,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        });
      }

    } else {

      if ($('.home-collections-tab .product-list').hasClass('slick-initialized')) {
        $('.home-collections-tab .product-list').slick('unslick');
      }

    }

  }

  mobileSlider();

  $(window).on('resize', function () {
    mobileSlider();
  });

});


document.addEventListener("DOMContentLoaded", function () {

  function initFooterAccordion() {
    const items = document.querySelectorAll('.footer-main-row .foote-col');

    // Remove existing listeners by cloning
    items.forEach(item => {
      const header = item.querySelector('.footer-header');

      if (header) {
        const newHeader = header.cloneNode(true);
        header.parentNode.replaceChild(newHeader, header);
      }
    });

    if (window.innerWidth <= 550) {

      // Newsletter open by default
      document.querySelector('.newsletter-footer')
        ?.classList.add('active');

      items.forEach(item => {

        // Skip last child
        if (item.matches('.foote-col:last-child')) return;

        const header = item.querySelector('.footer-header');

        if (header) {
          header.addEventListener("click", function () {

            items.forEach(el => {
              if (
                el !== item &&
                !el.matches('.foote-col:last-child')
              ) {
                el.classList.remove('active');
              }
            });

            item.classList.toggle('active');
          });
        }
      });

    } else {
      // Remove accordion on desktop
      items.forEach(item => {
        item.classList.remove('active');
      });
    }
  }

  initFooterAccordion();

  window.addEventListener("resize", initFooterAccordion);

});


